import { usePage } from "@inertiajs/react"

import { ProfileForm } from "@/components/features/profiles/profile-form"
import { StaffLayout } from "@/components/layouts/staff-layout"
import { MainContainer } from "@/components/ui/container"

type SharedUser = {
  name: string
  email: string
  initials: string
  avatar: string | null
}

export default function StaffProfilesEdit() {
  const { user } = usePage<{ user: SharedUser | null }>().props

  if (!user) return null

  return (
    <StaffLayout>
      <MainContainer size="xs">
        <ProfileForm defaultValues={{ name: user.name, email: user.email }} />
      </MainContainer>
    </StaffLayout>
  )
}
